export default __webpack_public_path__ + "132de3ce3cc18c4075cdb4cf0dde91ee.png";